module.exports = __webpack_public_path__ + "img/review-grid-section-05.05d4cd42.png";